// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { Contract, ContractLineItem, Discount, Service } from "../../../Utilities";

export type Base = {
	displayOrder: ContractLineItem["displayOrder"] | null;
	description: ContractLineItem["description"];
	isDiscount: ContractLineItem["isDiscount"];
	amount: ContractLineItem["amount"] | null;
	dateAdded: ContractLineItem["dateAdded"] | null;
	contractID: Contract["id"] | null;
	discountID: Discount["id"] | null;
	parentContractLineItemID: ContractLineItem["id"] | null;
	serviceID: Service["id"] | null;
};

export type Create = Base & {
	childContractLineItems: CreateInParentContractLineItem[];
};

export type CreateRequiredKey = Extract<keyof Create, "amount">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	displayOrder: null,
	description: "",
	isDiscount: false,
	amount: null,
	dateAdded: null,
	childContractLineItems: [],
	contractID: null,
	discountID: null,
	parentContractLineItemID: null,
	serviceID: null,
};

export type Detail = Base & {
	dateRemoved: ContractLineItem["dateRemoved"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInContract = Omit<Create, "contractID">;

export type CreateInContractRequiredKey = Exclude<CreateRequiredKey, "contractID">;

export type CreateInContractSubset<K extends keyof CreateInContract = keyof CreateInContract> = Pick<
	CreateInContract,
	CreateInContractRequiredKey | K
>;

export const blankItemInContract: CreateInContract = omitKeys(initialCreate, ["contractID"]);

export type CreateInParentContractLineItem = Omit<Create, "parentContractLineItemID">;

export type CreateInParentContractLineItemRequiredKey = Exclude<CreateRequiredKey, "parentContractLineItemID">;

export type CreateInParentContractLineItemSubset<
	K extends keyof CreateInParentContractLineItem = keyof CreateInParentContractLineItem,
> = Pick<CreateInParentContractLineItem, CreateInParentContractLineItemRequiredKey | K>;

export const blankItemInParentContractLineItem: CreateInParentContractLineItem = omitKeys(initialCreate, [
	"parentContractLineItemID",
]);
